
import { Link } from 'react-router-dom';
import SEOHead from '../components/feature/SEOHead';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <SEOHead
        title="Página Não Encontrada - Take Lead"
        description="A página que você está procurando não foi encontrada."
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/404`}
      />
      <div className="text-center">
        <h1 className="text-6xl font-bold text-blue-400 mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-4">Página Não Encontrada</h2>
        <p className="text-gray-400 mb-8">A página que você está procurando não existe.</p>
        <Link 
          to="/" 
          className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
        >
          <i className="ri-home-line mr-2"></i>
          Voltar ao Início
        </Link>
      </div>
    </div>
  );
}